export default __webpack_public_path__ + "svg/calendar/2025/0/abril.svg?363b7d3e";